RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    const session = state.session = new Backbone.Model({
        url: '/api/sessions'
    });

    state.utils.overrideStateGet(session);
    state.utils.overrideStateSet(session);

    /**
     * A property map transforming settings into session state, and session
     * state into persistence.
     * @type {*[]}
     */
    const statePropertyMap = [
        {
            settingProperty: 'widgets',
            stateProperty: 'widgets',
            persistenceProperty: 'widgets',
            path: 'sessionSettings'
        }
    ];

    /**
     * Initializes session state from properties.
     * @param session
     * @param properties
     */
    function initializeSessionFromProperties(session, properties) {
        state.utils.initializeState('session', 'sessionSettings', statePropertyMap, session, properties);
    }

    (function () {

        let hasInitialized = false;

        session.initialize = function (properties) {
            if (hasInitialized) {
                throw 'not supported: user cannot be initialized more than once.';
            }
            initializeSessionFromProperties(this, properties);
            hasInitialized = true;
        };

    }());

});
